import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import InformationRequestCreatePage from './information-request-create'
import InformationRequestUpdate from './information-request-update'
import InformationRequestsListPage from './information-requests-list'

const infromationRequestRoutes: Route[] = [
  {
    path: Paths.INFORMATION_REQUESTS_PAGE,
    element: <InformationRequestsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.INFORMATION_REQUEST_CREATE_PAGE,
    element: <InformationRequestCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.INFORMATION_REQUEST_UPDATE_PAGE,
    element: <InformationRequestUpdate />,
    roles: [RoleEnum.ADMIN]
  }
]

export default infromationRequestRoutes
